import { Component, OnInit } from '@angular/core';
import {ITransaction, Transaction} from "../../../../models/transaction.model";
import {TransactionService} from "../../../../services/transaction.service";
import {UserService} from "../../../../services/user.service";
import {AuthService} from "../../../../services/auth.service";
import {Router} from "@angular/router";
import * as XLSX from "xlsx";
import {OrderService} from "../../../../services/order.service";
import {Order} from "../../../../models/order.model";
import {environment} from "../../../../environments/environment";
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { ShopService } from '../../../../services/shop.service';
import { Shop } from '../../../../models/shop.model';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-commande',
  templateUrl: './commande.component.html',
  styleUrls: ['./commande.component.scss']
})
export class CommandeComponent implements OnInit {

  transactions: any[] = [];
  allTransactionsTmp: ITransaction[] = [];
  search: any;
  page = 1;
  perPage = 15;
  sorted = 1;
  sorted2 = false;
  url_photo: String;
  totalItems :any;
  // @ts-ignore
  currentTransaction: ITransaction = [];

  currentOrder: Order;
  isFiltreDate: boolean;
  constructor(private transactionService: TransactionService,
              private userService: UserService, private orderService: OrderService,
              private authService: AuthService, private router: Router,
              private datePipe: DatePipe, private shopService: ShopService,
               private fb: FormBuilder) { }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.loadTransactions_v1();
    },error=>{
      this.router.navigate(['/login']);
    });
    this.url_photo = environment.url_photo;
  }

  disableEndDate = true;
  displayError = false;
  //Récupération de la date de début
  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }
  // Récupération de la date de fin
  endDateVal: any = null;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
   // console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  dateForm = this.fb.group({
    beginDate: ['', Validators.required],
    endDate: ['', Validators.required]
  })

  areDatesEmpty(): boolean {
    const beginDate = this.dateForm.get('beginDate').value;
    const endDate = this.dateForm.get('endDate').value;
    return !beginDate && !endDate;
  }

  refresh() {
    this.loadTransactions_v1();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }

  filterByDate() {
    const beginDate = this.dateForm.get('beginDate').value;
    const endDate = this.dateForm.get('endDate').value;

    // Vérifier si les deux champs de date sont vides
    if (!beginDate || !endDate) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    } else {
      const beginDateISO = new Date(beginDate).toISOString();
      const endDateISO = new Date(endDate).toISOString();
      // console.log("Date sélectionnée")
      // console.log('beginDate:', beginDateISO);
      // console.log('endDate:', endDateISO);

      this.transactionService.transactionOrder_v1_1(beginDateISO, endDateISO, this.page - 1, this.perPage).subscribe(data => {
        this.transactions = data.content;
        this.totalItems = data.totalElements;
        this.isFiltreDate = true;
        this.transactions.forEach(element => {
          if (element.createdBy != null) {
            this.userService.getidUser(element.createdBy).subscribe(rs => {
              let trUser = rs;
              element.user = trUser;
            });
          } else {
            if (element.userID != null) {
              if (isNaN(Number(element.userID))) {
                this.userService.getByUSerName(element.userID).subscribe(rs => {
                  let trUser = rs;
                  element.user = trUser;
                });
              } else {
                this.userService.getidUser(Number(element.userID)).subscribe(rs => {
                  let trUser = rs;
                  element.user = trUser;
                });
              }

            }
          }
        });
        this.allTransactionsTmp = this.transactions;
      });
    }
  }

  loadTransactions_v1 = () =>{
    this.transactionService.transactionOrder_v1(this.page-1, this.perPage).subscribe(data => {
      this.transactions = data.content;
      this.totalItems = data.totalElements;
      // console.log("Liste de tous les transactions ###");
      // console.log(data.content);
      this.isFiltreDate = false;
      this.transactions.forEach(element => {
        if (element.createdBy != null) {
          this.userService.getidUser(element.createdBy).subscribe(rs => {
            let trUser = rs;
            element.user = trUser;
          });
        } else {
          if (element.userID != null) {
            if (isNaN(Number(element.userID))) {
              this.userService.getByUSerName(element.userID).subscribe(rs => {
                let trUser = rs;
                element.user = trUser;
              });
            } else {
              this.userService.getidUser(Number(element.userID)).subscribe(rs => {
                let trUser = rs;
                element.user = trUser;
              });
            }

          }
        }
      });
      this.allTransactionsTmp = this.transactions;
      // console.log("Liste des transactions")
      // console.log(this.transactions)
    })
  };

  loadTransactions = () =>{
    this.transactionService.transactionOrder().subscribe(data => {
      this.transactions = data;
      // console.log("Liste de tous les transactions");
      // console.log(data);
      this.transactions.forEach(element => {
        if (element.createdBy != null) {
          this.userService.getidUser(element.createdBy).subscribe(rs => {
            let trUser = rs;
            element.user = trUser;
          });
        } else {
          if (element.userID != null) {
            if (isNaN(Number(element.userID))) {
              this.userService.getByUSerName(element.userID).subscribe(rs => {
                let trUser = rs;
                element.user = trUser;
              });
            } else {
              this.userService.getidUser(Number(element.userID)).subscribe(rs => {
                let trUser = rs;
                element.user = trUser;
              });
            }

          }
        }
      });
      this.allTransactionsTmp = this.transactions;

    })
  };

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
    this.loadTransactions_v1();
    // console.log(this.perPage);
  }

  searchFilter($event: KeyboardEvent) {
    // console.log(this.search);
    this.search = this.search.toString().toLowerCase();
    this.transactions = this.allTransactionsTmp;
    this.transactions = this.transactions.filter(value =>
      value.transactionID?.toUpperCase().includes(this.search)  || value.transactionID?.toLowerCase().includes(this.search)
      || value.user?.firstname?.toUpperCase().includes(this.search) || value.user?.firstname?.toLowerCase().includes(this.search)
      || value.user?.lastname?.toUpperCase().includes(this.search) || value.user?.lastname?.toLowerCase().includes(this.search)
      || value?.paymentMethod?.toUpperCase().includes(this.search) || value?.paymentMethod?.toLowerCase().includes(this.search)
      || value?.date.toString()?.toUpperCase().includes(this.search) || value?.date.toString()?.toLowerCase().includes(this.search)
      || value?.typeTransaction?.name?.toUpperCase().includes(this.search) || value?.typeTransaction?.name.toLowerCase().includes(this.search)
      || value.amount==this.search
      || value.successfulPayment===this.search
    );
  }

  selectTransactionStatus_v1(value: string) {
    // Créez une nouvelle liste vide pour stocker les transactions filtrées
    let selectTransaction: ITransaction[] = [];

    this.transactions = this.allTransactionsTmp;

    if (value !== 'all') {
      if (value === "validée") {
        selectTransaction = this.transactions.filter(value1 => value1?.successfulPayment === true);
      } else if (value === "annulée") {
        selectTransaction = this.transactions.filter(value1 => value1?.successfulPayment === false || value1?.successfulPayment === null);
      }

      this.transactions = selectTransaction;
      // Affichez les informations de débogage pour vous assurer que tout fonctionne comme prévu
      // console.log("-_-_-_-_-_-_--_-_-_-_-_-_-_-_-_-_-");
      // console.log(this.transactions);
    } else {
      this.transactions = this.allTransactionsTmp;
    }
  }

  selectTransactionStatus(value: any) {
    const selectTransaction: ITransaction[] = [];
    this.transactions = this.allTransactionsTmp;
    if (value !== 'all') {
      if(value=="validée"){
        this.transactions.forEach(value1 => {
          if (value1?.successfulPayment) {
            selectTransaction.push(value1);
          }
        });
      }
      if(value=="annulée"){
        this.transactions.forEach(value1 => {
          if (value1?.successfulPayment==null || value1.successfulPayment == false) {
            selectTransaction.push(value1);
          }
        });
      }
      this.transactions = selectTransaction;
    }else{
      this.transactions = this.allTransactionsTmp;
    }
  }

  onViewOrder(tr: any) {
    this.currentTransaction = tr;
    this.orderService.getIdOrderByOrderID(tr.orderID).subscribe(order =>  {
      this.currentOrder = order;
      this.shopService.getShopByShopId(this.currentOrder.orderItems[0].productShopID).subscribe(shop => {
        let resultshop : Shop;
        resultshop = shop;
        this.currentOrder.sellerLastName = resultshop.sellerId.lastname;
        this.currentOrder.sellerFirstName = resultshop.sellerId.firstname;
        this.currentOrder.sellerPhoneNumber = resultshop.sellerId.phoneNumber;
        //console.log("Détailsdelacommande########");
        //console.log(this.currentOrder);
      });
    });
  }

  exportexcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);

  }


  /*
 filtre par date
  */

  beginDate: any = null;
  endDate: any = null;

  filterTransactions() {
    if (this.endDate == null || this.beginDate== null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez choisir une date de début et une date de fin s\'il vous plaît',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }
    if (this.endDate!= null && this.beginDate!= null && this.beginDate <= this.endDate) {
      const dateString = this.endDate;
      const date = new Date(dateString);
      date.setDate(date.getDate() + 1); // ajoute 1 jour à la date
      this.endDate = this.datePipe.transform(date,'yyyy-MM-dd');
      this.transactions = this.allTransactionsTmp;
      this.transactions = this.transactions.filter((t) => {
        return (this.beginDate == null || t.date >= this.beginDate) &&
          (this.endDate == null || t.date <= this.endDate);
      });
    }
  }

  resetFilter() {
    this.loadTransactions_v1();
    this.beginDate = null;
    this.endDate = null;
  }

  pagination(){
    if(this.isFiltreDate){
      this.filterByDate()
    }
    else{
      this.loadTransactions_v1();
    }

  }

  trier(columnName: keyof Transaction) {
    this.sorted = -this.sorted;
    this.transactions.sort((a, b) => a[columnName] > b[columnName] ? this.sorted : -this.sorted);
  }

  sort2() {
    if (this.sorted2 == false) {
      // @ts-ignore
      this.transactions.sort((a, b) => a?.user?.firstname > b?.user?.firstname ? 1 : a?.user?.firstname < b?.user?.firstname ? -1 : 0);
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.transactions.sort((a, b) => a?.user?.firstname < b?.user?.firstname ? 1 : a?.user?.firstname > b?.user?.firstname ? -1 : 0);
      this.sorted2 = false;
    }
  }
}
